import Navbar from "../components/Navbar/Navbar";
import AddEducation from "../components/profile-forms/AddEducation";

const AddEducationPage = () => {
    return ( 
        <>
        <Navbar/>
        <AddEducation/>
        </>
     );
}
 
export default AddEducationPage;